import styled from 'styled-components'
import { Media } from '../../theme'
import topBg from './image/top-bg.webp'

const maxWidth = '1500px'

export const Wrapper = styled.div<{ bg?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  top: 0px;
  position: fixed;
  z-index: 1000;
  overflow: hidden;
  background-image: ${({ bg }) => (bg ? `url(${bg})` : `url(${topBg})`)};
  background-size: cover;
  @media (max-width: ${maxWidth}) {
    justify-content: center;
  }
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const CenterImg = styled.img`
  width: auto;
  height: 48px;
`

export const CloseIconWrapper = styled.img`
  cursor: pointer;
  width: 36px;
  height: 36px;
  position: absolute;
  right: 10px;
  @media (max-width: ${maxWidth}) {
    margin-right: 0;
    position: absolute;
    right: 10px;
    top: 6px;
  }
`
